import { motion } from "framer-motion";
import { Building2, Handshake, ShieldCheck } from "lucide-react";

const stats = [
  {
    icon: Building2,
    title: "Работа с предприятиями",
    text: "Промышленность, транспорт, строительство, сельское хозяйство.",
  },
  {
    icon: Handshake,
    title: "Прямые контракты",
    text: "Отношения с производителями и официальными дистрибьюторами.",
  },
  {
    icon: ShieldCheck,
    title: "Ответственность",
    text: "Документы, спецификации и сопровождение сделки на каждом этапе.",
  },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="section bg-white relative overflow-hidden"
    >
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <div className="eyebrow mb-6">О компании</div>
            <h2 className="font-display text-[#0A192F] text-3xl sm:text-4xl lg:text-5xl font-semibold leading-[1.1] tracking-tight">
              Надёжный B2B-поставщик промышленной продукции.
            </h2>
            <p className="mt-8 text-slate-600 text-base lg:text-lg leading-relaxed">
              ООО «Бизора Логистик» — оптовая B2B-компания, работающая на промышленном
              рынке России. Мы осуществляем поставки комплектующих и запасных частей
              для промышленного и телекоммуникационного оборудования, горюче-смазочных
              материалов (ГСМ) и хозяйственных товаров, промышленной мебели и фурнитуры,
              а также маломощных электродвигателей и электромеханических решений.
            </p>
            <p className="mt-4 text-slate-600 text-base lg:text-lg leading-relaxed">
              Работаем с несколькими промышленными направлениями одновременно: от базового
              снабжения предприятий до подбора технических решений для электротранспорта,
              складской техники, промышленной автоматизации и электроприводных систем.
              Наша задача — стать вашим постоянным партнёром по снабжению и брать на себя
              логистику.
            </p>

            <div className="mt-10 flex items-center gap-6 flex-wrap">
              <div className="flex items-center gap-3">
                <div className="w-1 h-10 bg-[#FF6B00]" />
                <div>
                  <div className="font-display text-[#0A192F] text-lg font-semibold">
                    ООО «Бизора Логистик»
                  </div>
                  <div className="text-sm text-slate-500">Оптовая торговля · B2B</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right visual */}
          <div className="lg:col-span-7">
            <div className="relative">
              <div className="relative overflow-hidden">
                <img
                  src="https://images.unsplash.com/photo-1684695749267-233af13276d0"
                  alt="Склад Бизора Логистик"
                  className="w-full h-[440px] lg:h-[560px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A192F]/80 via-[#0A192F]/10 to-transparent" />
                <div className="absolute top-6 left-6 glass-card-dark px-4 py-2 text-white text-xs uppercase tracking-[0.2em]">
                  Промышленное снабжение
                </div>
              </div>

              {/* Floating glass card */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.6 }}
                className="hidden md:block absolute -bottom-10 -left-10 max-w-md glass-card p-6"
              >
                <div className="font-display text-[#0A192F] text-sm uppercase tracking-[0.16em] text-[#FF6B00] mb-3">
                  Наш подход
                </div>
                <div className="text-slate-800 text-base leading-relaxed">
                  Индивидуальное решение под каждый запрос: подбор аналогов,
                  консолидированные поставки и прозрачная работа с документами.
                </div>
              </motion.div>
            </div>

            <div className="mt-16 lg:mt-24 grid sm:grid-cols-3 gap-6">
              {stats.map((s, i) => {
                const Icon = s.icon;
                return (
                  <motion.div
                    key={s.title}
                    initial={{ opacity: 0, y: 16 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-40px" }}
                    transition={{ duration: 0.5, delay: i * 0.08 }}
                    className="border-t border-slate-200 pt-6"
                    data-testid={`about-stat-${i}`}
                  >
                    <Icon className="w-6 h-6 text-[#FF6B00] mb-4" />
                    <div className="font-display text-[#0A192F] font-semibold text-base">
                      {s.title}
                    </div>
                    <div className="mt-2 text-sm text-slate-600 leading-relaxed">
                      {s.text}
                    </div>
                  </motion.div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
